var network_features_module = angular.module('honeybook.network.features', [
    'honeybook.network.features.likes',
    'honeybook.network.features.feed_item',
    'honeybook.network.features.referral',
    'honeybook.network.features.project',
    'honeybook.network.features.banners'
]);
